'use strict';

import EmptyRouterView from '../../app/views/EmptyRouterView.vue';

export const speciesRoutes = [
  {
    path: '/species',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'species.list',
        component: () => import('../views/SpeciesListView.vue'),
      },
      {
        path: 'add',
        name: 'species.add',
        component: () => import('../views/SpeciesAddView.vue'),
      },
      {
        path: ':speciesId',
        component: EmptyRouterView,
        children: [
          {
            path: 'edit',
            name: 'species.edit',
            props: true,
            meta: {
              requiresAuth: true,
            },
            component: () => import('../views/SpeciesEditView.vue'),
          },
        ],
      },
    ],
  },
];
